import { orderBy } from 'lodash-es'

import { ISessionListItem } from '@/httpRequest/modules/mesperyIm/sessionList'

export const sortSessions = (sessions: ISessionListItem[]) => {
  return orderBy(
    sessions,
    [
      // 第一排序条件：未读消息优先
      (item) => {
        const isUnread =
          item.last_message_created_at > Number(item.last_read_at)
        return isUnread ? 1 : 0 // 1表示未读，0表示已读
      },
      // 第二排序条件：消息时间倒序
      'last_message_created_at'
    ],
    ['desc', 'desc'] // 双降序排列
  )
}

export const sortSessionsById = (
  sessions: ISessionListItem[],
  targetSessionId?: string // 新增目标会话ID参数
) => {
  return orderBy(
    sessions,
    [
      // 第一优先级：指定会话置顶
      (item) => item.session_id === targetSessionId
    ],
    ['desc']
  )
}

export const formatSpaces = (text: string) => {
  return text
    .replace(/\n/g, '<br/>')
    .replace(/[\u0020\u3000]{2,}/g, (m) => '\u00A0'.repeat(m.length))
}
